import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import I18n from 'vue-i18n'
import './utils/axios'
import VueLazyload from 'vue-lazyload'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/reset.css'
import ElementUI from 'element-ui';
import Cookies from 'js-cookie'

import VideoPlayer from 'vue-video-player'
import "video.js/dist/video-js.css"
import 'vue-video-player/src/custom-theme.css';

Vue.config.productionTip = false
Vue.use(VueLazyload)
Vue.use(I18n)
Vue.use(VideoPlayer)
Vue.use(ElementUI);
Vue.prototype.$cookies = Cookies
/*---------使用语言包-----------*/
const i18n = new I18n({
  locale: Cookies.get('SET_LANG') || 'en-US', 
  // locale: Cookies.get('SET_LANG') || 'zh-CN', // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': require('./locales/zh-CN.json'), // 中文语言包
    'en-US': require('./locales/en-US.json') // 英文语言包
  }
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')